import { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

type GraphicAreaBodyProps = HTMLAttributes<HTMLDivElement>

export function GraphicAreaBody(props: GraphicAreaBodyProps) {
  return (
    <div
      {...props}
      className={twMerge([
        'pl-1 pr-5 mr-1.5',
        'overflow-y-auto',
        'flex-1 flex-col',
        props.className,
      ])}
    />
  )
}
